import React from 'react';
export function CTASection() {
  return <section id="start" className="py-24 bg-blue-600 text-white" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-25">
        <h2 className="text-3xl md:text-4xl font-extrabold tracking-tight" data-id="element-26">
          Let's Build Your AI-Powered Future
        </h2>
        <p className="mt-4 text-lg md:text-xl leading-8 text-blue-100 max-w-3xl mx-auto" data-id="element-27">
          Bring us a process, product flow, or KPI target. We'll design a rapid
          AI pilot, prove impact, and scale it with enterprise-grade reliability
          and security.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4" data-id="element-28">
          <a href="#" className="bg-white text-blue-600 hover:bg-blue-50 px-8 py-3 rounded-lg text-lg font-semibold shadow-lg transition-colors" data-id="element-29">
            Book a Value Mapping Session
          </a>
          <a href="#" className="bg-blue-700 text-white hover:bg-blue-800 px-8 py-3 rounded-lg text-lg font-semibold shadow-lg border-2 border-blue-500 transition-colors" data-id="element-30">
            Download Use-Case Fact Sheets
          </a>
        </div>
      </div>
    </section>;
}